import { setComponentMapOverrides } from '@jutro/uiconfig';
import SasriaFNOLBIWizard from './SasriaFNOLBIWizard';
import SasriaBusinessInterruption from './pages/SasriaBusinessInterruption/SasriaBusinessInterruption';
import SasriaFNOLWherePage from '../sasria-capability-fnol-common-react/Where/SasriaFNOLWherePage';
import SasriaFNOLSummaryPage from '../sasria-capability-fnol-common-react/Summary/SasriaFNOLSummaryPage';
import DocumentsPage from '../../capabilities-react/gw-capability-fnol-common-react/pages/AdditionalInformation/AdditionalInformationPage';

setComponentMapOverrides(
    {
        SasriaFNOLBIWizard: { component: 'SasriaFNOLBIWizard' },
        SasriaFNOLWherePage: { component: 'SasriaFNOLWherePage' },
        SasriaBusinessInterruption: { component: 'SasriaBusinessInterruption' },
        SasriaFNOLSummaryPage: { component: 'SasriaFNOLSummaryPage'},
        DocumentsPage: {component: 'DocumentsPage'}
    },
    {
        SasriaFNOLBIWizard,
        SasriaFNOLWherePage,
        SasriaBusinessInterruption,
        SasriaFNOLSummaryPage,
        DocumentsPage
    }
);

export {
    SasriaFNOLBIWizard as default,
    SasriaFNOLWherePage,
    SasriaBusinessInterruption,
    SasriaFNOLSummaryPage,
    DocumentsPage
};
